import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { TransferRequirements } from '../types';
import useGetDocumentRequestLabel from './use-get-document-request-label';
type UseRequirementsTitleParams = {
  missingRequirements: TransferRequirements;
  isContinuingOnDesktop: boolean;
  isAppClipProcessing: boolean;
};
const useRequirementsTitle = t0 => {
  const $ = _c(16);
  const {
    missingRequirements,
    isContinuingOnDesktop,
    isAppClipProcessing
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "transfer.requirements"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const getDocumentRequestLabel = useGetDocumentRequestLabel();
  const {
    liveness,
    documents
  } = missingRequirements;
  const transferringLiveness = !!liveness;
  const transferringIdDoc = !!documents.length && !isContinuingOnDesktop;
  let t2;
  if ($[1] !== documents[0] || $[2] !== documents.length || $[3] !== getDocumentRequestLabel || $[4] !== isAppClipProcessing || $[5] !== t || $[6] !== transferringIdDoc || $[7] !== transferringLiveness) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const documentKind = documents.length === 1 ? getDocumentRequestLabel(documents[0].config.kind) : t(_temp);
      if (isAppClipProcessing) {
        t2 = {
          title: t(_temp2)
        };
        break bb0;
      }
      if (transferringLiveness && transferringIdDoc) {
        t2 = {
          title: t(_temp3, {
            documentKind
          }),
          subtitle: t(_temp4, {
            documentKind
          })
        };
        break bb0;
      }
      if (transferringIdDoc) {
        t2 = {
          title: t(_temp5, {
            documentKind
          }),
          subtitle: t(_temp6, {
            documentKind
          })
        };
        break bb0;
      }
    }
    $[1] = documents[0];
    $[2] = documents.length;
    $[3] = getDocumentRequestLabel;
    $[4] = isAppClipProcessing;
    $[5] = t;
    $[6] = transferringIdDoc;
    $[7] = transferringLiveness;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  let t3;
  if ($[9] !== t) {
    t3 = t(_temp7);
    $[9] = t;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t) {
    t4 = t(_temp8);
    $[11] = t;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = {
      title: t3,
      subtitle: t4
    };
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
export default useRequirementsTitle;
function _temp($) {
  return $.documents;
}
function _temp2($_0) {
  return $_0.title.appclip;
}
function _temp3($_1) {
  return $_1.title.livenessWithIdDoc;
}
function _temp4($_2) {
  return $_2.subtitle.livenessWithIdDoc;
}
function _temp5($_3) {
  return $_3.title.idDoc;
}
function _temp6($_4) {
  return $_4.subtitle.idDoc;
}
function _temp7($_5) {
  return $_5.title.liveness;
}
function _temp8($_6) {
  return $_6.subtitle.liveness;
}